import React from 'react'

export function useStableAccessor<T>(value: T) {
  const initialPersisterKey = React.useRef<{ value: T }>({ value })
  const getValue = React.useCallback(() => {
    return initialPersisterKey.current.value
  }, [initialPersisterKey])
  initialPersisterKey.current.value = value
  return getValue
}
